<template>
  <div v-if="data">
    <div class="row pb-4">
      <div
        class="col-12 col-md-8 border-right"
      >
        <div class="form-group">
          <label>User</label>
          <autocomplete
            ref="first"
            :allow-creation="true"
            :initial-value="data.user_id"
            :initial-display="user ? user.name : null"
            :class="{ 'is-invalid': ((error && error.errors.user_id) ? error.errors.user_id : []).length > 0 }"
            :input-class="['form-control', { 'is-invalid': ((error && error.errors.user_id) ? error.errors.user_id : []).length > 0 }]"
            class="align-self-center"
            placeholder="Select a user...  "
            source="/users/search/?q="
            results-property="data"
            @selected="selectedUser"
            @clear="selectedUser"
            @create="$router.replace({
              name: 'users.create',
              query: {
                onComplete: $route.path
              }
            })"
          />

          <router-link
            v-if="data.user_id"
            :to="{ name: 'users.view', hash: '#details', params: { userId: data.user_id } }"
          >
            Edit user
          </router-link>

          <form-control-error
            :errors="(error && error.errors.user_id) ? error.errors.user_id : []"
          />
        </div>

        <div
          v-if="!startedWithChannel"
          class="form-group"
        >
          <label>Channel</label>
          <autocomplete
            :initial-value="data.channel_id"
            :initial-display="data.channel ? data.channel.name : null"
            :class="{ 'is-invalid': ((error && error.errors.channel_id) ? error.errors.channel_id : []).length > 0 }"
            :input-class="['form-control', { 'is-invalid': ((error && error.errors.channel_id) ? error.errors.channel_id : []).length > 0 }]"
            class="align-self-center"
            placeholder="Select a channel...  "
            source="/channels/?search="
            results-property="data"
            @selected="selectedChannel"
            @clear="selectedChannel"
          />

          <form-control-error
            :errors="(error && error.errors.user_id) ? error.errors.user_id : []"
          />
        </div>

        <form-control
          v-model="data.job_title"
          title="Job Title"
        />

        <div class="form-group">
          <label>Long Bio</label>
          <HtmlEditor
            v-model="data.long_bio"
            class="d-none d-md-block"
            :class="{
              'is-invalid': ((error && error.errors.long_bio) ? error.errors.long_bio : []).length > 0
            }"
            :token="`Bearer ${$login.getToken()}`"
            :image-upload-url="imageUploadUrl"
            :file-upload-url="fileUploadUrl"
          />
        </div>

        <div class="form-group">
          <label>Short Bio</label>
          <HtmlEditor
            v-model="data.short_bio"
            class="d-none d-md-block"
            :class="{
              'is-invalid': ((error && error.errors.short_bio) ? error.errors.short_bio : []).length > 0
            }"
            :token="`Bearer ${$login.getToken()}`"
            :image-upload-url="imageUploadUrl"
            :file-upload-url="fileUploadUrl"
          />
        </div>
      </div>

      <div class="col-12 col-md-4">
        <social-link v-model="data.social_links" />
      </div>
    </div>
  </div>
</template>

<script>
import {HtmlEditor} from '@frontend/components'
import SocialLink from '@/components/SocialLink'
import Autocomplete from '@/components/Autocomplete'

export default {
  components: {
    SocialLink,
    Autocomplete,
    HtmlEditor,
  },
  props: {
    channel: {
      required: false,
      type: Object,
      default: null,
    },
    analyst: {
      required: false,
      type: Object,
      default () {
        return {

          user_id: null,
          channel_id: null,
          social_links: null,
        }
      },
    },
  },

  data () {
    return {
      error: null,
      data: {},
      user: null,
      loading: false,
      startedWithChannel: false,
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  watch: {
    channel () {
      this.setChannelFromProp()
    },
    analyst: {
      deep: true,
      handler () {
        this.reset()
      },
    },
  },

  beforeMount () {
    this.reset()
  },

  methods: {
    reset () {
      this.data = this.analyst
      this.user = this.analyst.user

      this.setChannelFromProp()
    },
    setChannelFromProp () {
      this.startedWithChannel = !!this.channel
      if (this.channel) {
        this.data.channel_id = this.channel.id
      }
    },
    selectedUser (user) {
      if (user) {
        user = user.object || user
        this.user = user
        this.data.user_id = user ? user.id : null
      } else {
        this.data.user_id = null
      }
    },
    selectedChannel (channel) {
      if (channel) {
        channel = channel.object || channel
        // this.channel = channel
        this.data.channel_id = channel ? channel.id : null
      } else {
        this.data.channel_id = null
      }
    },

    save () {
      if (!this.loading) {
        const method = this.data.id ? 'put' : 'post'
        const url = this.data.id ? `/analysts/${this.data.id}` : '/analysts'

        this.$http[method](url, this.data)
            .then((response) => {
              this.loading = false
              this.$emit('save-success', response)
            })
            .catch((error) => {
              this.loading = false
              if (error.response && error.response.data && error.response.data.errors) {
                this.error = error.response.data
              }
              this.$emit('save-fail', error)
            })
      }
    },
  },
}
</script>
